import DatePicker from 'react-datepicker';
import { GetComponentProps } from '../../utils/types';
import { Button } from '@akin-home/buttons/native';
import { format } from 'date-fns';

type Props = {
  value: Date;
  onChange: (ev: any, value: Date | null) => void;
};

export const TimePicker = (props: Props) => {
  const handleChange: GetComponentProps<DatePicker>['onChange'] = (
    value,
    ev
  ) => {
    props.onChange(ev, value);
  };

  return (
    <DatePicker
      selected={props.value}
      onChange={handleChange}
      showTimeSelect
      showTimeSelectOnly
      customInput={
        <Button variant="secondary">{format(props.value, 'h:mm a')}</Button>
      }
      timeIntervals={1}
    />
  );
};
